module.exports = __webpack_public_path__ + "static/media/ico-checked-green.70c41fe4.svg";